// extracted by mini-css-extract-plugin
export default {"container":"tabLastEdit_container__biK3L"};